import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { PapiGallection } from '@wix/da-papi-types';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import FolderDescription from '../../FolderDescription';
import { FolderListDesktop } from '../FolderList';
import Flex from '@wix/da-ds/pkg/Flex';

import s from './FolderHeaderDesktop.scss';

export interface Props {
  selectedFolder: PapiGallection;
  subfolders?: PapiGallection[];
  hasDeviations?: boolean;
  isVisitorView?: boolean;
  activeQuery?: string;
}

const FolderHeaderDesktop: FC<Props> = ({
  selectedFolder,
  subfolders,
  hasDeviations,
  isVisitorView,
  activeQuery,
}) => {
  const { t } = useTranslation();
  const foldersExpandedByDefault = !hasDeviations;
  const hasSubfolders = subfolders && subfolders.length > 0;
  // When searching we remove the subfolders
  const showSubFolders = activeQuery && activeQuery !== '' ? false : true;

  return (
    <Flex direction="column" gap={24}>
      <FolderDescription folder={selectedFolder} />
      {hasSubfolders && showSubFolders && (
        <BiLoggerContextProvider value={{ sectionname: 'subfolders' }}>
          <FolderListDesktop
            expandedByDefault={foldersExpandedByDefault}
            withCreateButton={!isVisitorView}
            withFolderActions={!isVisitorView}
            withDragToOrder={!isVisitorView}
            withHeader
          />
        </BiLoggerContextProvider>
      )}
      {/* Empty div to make flexbox happy */}
      {!hasSubfolders && hasDeviations && <div></div>}
      {hasSubfolders && hasDeviations && (
        <Heading className={cn(s['heading'], s['files-heading'])}>
          {t('studio.table.heading')}
        </Heading>
      )}
    </Flex>
  );
};
FolderHeaderDesktop.displayName = 'FolderHeaderDesktop';

export default FolderHeaderDesktop;
